import { useParams } from "react-router-dom";
import { PageLayout } from "@/components/templates/page-layout";
import { ZoneForm } from "@/components/organisms/zone-form";
import { useZones } from "@/core/hooks/useZones";

export default function NouvelleZonePage() {
  const { siteId } = useParams<{ siteId: string }>();
  const { createZone } = useZones(siteId!);

  return (
    <PageLayout title="Nouvelle zone">
      <ZoneForm
        onSubmit={async (data) => {
          await createZone({
            name: data.name,
            planBlob: data.planBlob,
            planType: data.planType ?? "default",
          });
        }}
        redirectTo={`/sites/${siteId}`}
      />
    </PageLayout>
  );
}
